import { createSelector } from 'reselect';
import { SCOPE } from './types';

const selector = state => state[SCOPE];

export default selector;

export const appViewerSessionSelector = createSelector(
  selector,
  appViewerSession => {
    return appViewerSession.response
  },
);
